import React from 'react';
import PropTypes from 'prop-types';

import {GreyButton} from 'components/Button';
import Page from 'components/Page';

import ShowDealStatus from 'components/DealStatus';

import './style.css';

export class DealStatus extends React.PureComponent {
  renderButton() {
    const {deal, next} = this.props;

    if (deal.status === 'allocating' || deal.status === 'finalizing' || deal.status === 'finalized') {
      return (
        <GreyButton
          onClick={() => { next(); }}
          style={{margin: '0.5em 0'}}
          data-test="next"
        >
          Move to next stage
        </GreyButton>
      );
    }

    return '';
  }
  render() {
    const {deal} = this.props;

    const map = {
      allocating: 'Invite investors',
      finalizing: 'Split raise',
      finalized: 'Close deal',
    };

    return (
      <div styleName="wrapper">
        <h2>Status</h2>
        <Page>
          <ShowDealStatus status={deal.status} />
          {this.renderButton()}
        </Page>
      </div>
    );
  }
}

DealStatus.propTypes = {
  deal: PropTypes.object.isRequired,
  next: PropTypes.func.isRequired,
};

export default DealStatus;



// WEBPACK FOOTER //
// ./web/flows/deal/status_transitions/components/DealStatus/index.js